module.exports = __webpack_public_path__ + "static/media/3.6b600453.jpg";